import React from 'react';
import { FormattedMessage } from 'react-intl';

export const Stage = ({ stage = '', matchDay }): React.ReactElement => (
  [
    // ACM Primavera cases:
    'championship_-_final',
    'championship_-_semi-finals',
    // ACM Futuro cases:
    'play-off',
    'play-offs',
    'supercoppa_lega_finals',
    'relegation_play-offs_-_finals',
    'promotion_play-offs_-_finals',
    'promotion_play-offs_-_semi-finals',
    'promotion_play-offs_-_4th_round',
    'promotion_play-offs_-_3rd_round',
    'promotion_play-offs_-_2nd_round',
    'promotion_play-offs_-_1st_round',
  ].includes(stage)
    ? <FormattedMessage id={`match.stage.${stage}`} />
    : (
      <>
        <FormattedMessage id="match.day" />
        &nbsp;
        {matchDay}
      </>
    )
);
